import { useState } from "react";
import { MessageCircle, X } from "lucide-react";

export const WhatsAppFloat = () => {
  const [showNote, setShowNote] = useState(false);

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3" data-testid="whatsapp-float">
      {showNote && (
        <div className="max-w-[260px] rounded-2xl border border-border bg-white p-4 shadow-xl" data-testid="whatsapp-note">
          <div className="flex items-start justify-between gap-2">
            <p className="font-heading text-sm font-bold text-slate-900">WhatsApp — coming soon</p>
            <button onClick={() => setShowNote(false)} aria-label="Close" className="text-muted-foreground hover:text-slate-900" data-testid="whatsapp-note-close">
              <X className="h-4 w-4" />
            </button>
          </div>
          <p className="mt-1.5 text-xs leading-relaxed text-muted-foreground">
            Our WhatsApp line is being set up. Send the consultation form and we'll call or WhatsApp you back first.
          </p>
          <a href="#consultation" onClick={() => setShowNote(false)} className="mt-2.5 inline-block font-heading text-xs font-bold text-secondary hover:text-primary" data-testid="whatsapp-note-cta">
            Request a consultation →
          </a>
        </div>
      )}
      <button
        onClick={() => setShowNote((s) => !s)}
        aria-label="WhatsApp us"
        className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-green-600/30 transition-transform duration-200 hover:scale-110"
        data-testid="whatsapp-float-btn"
      >
        <MessageCircle className="h-7 w-7" />
      </button>
    </div>
  );
};
